import { FC, useCallback } from "react";
import { SvgArrowInCircle } from "../../../assets/icons/SvgArrowInCircle";
import { Button } from "../Button/Button";
import { QueryLayout } from "../Layout/QueryLayout";
import { IAdminChassisMarksFilter } from "common/models/admin/IAdminVehicleFilter copy";
import { CustomInput } from "../Input/CustomInput";
import { useGetChassisMarksQuery } from "services/vehicle/chassisApi";

export const AdminChassisMarksFilter: FC<IAdminChassisMarksFilter> = ({
  setIsFilterOpen,
  handleFilterReset,
  chassisMarkId,
  handleChassisMarkIdChange,
}) => {
  const {
    data: models,
    isLoading: isModelsLoading,
    isFetching: isModelsFetching,
    error: modelsError,
  } = useGetChassisMarksQuery();

  const handleFilterClose = useCallback(() => {
    setIsFilterOpen(false);
  }, []);

  return (
    <div
      className={`pointer-events-auto absolute top-[160px] right-[15px] z-20 h-fit overflow-hidden overflow-y-scroll rounded p-[5px]`}
    >
      <div
        className={`top-[65px] h-fit min-w-[350px] overflow-y-scroll rounded bg-white p-[15px] shadow-lg
        `}
      >
        <button
          className="absolute top-[10px] right-[10px] z-10 h-[32px] w-[32px] text-black 
        outline-none transition hover:text-primary focus:text-primary active:text-black"
          onClick={handleFilterClose}
        >
          <SvgArrowInCircle className="text-inherit" />
        </button>
        <h3 className="mb-[25px] text-center text-lg font-semibold">Фильтры</h3>
        <div className="grid gap-[15px]">
          <div>
            <div className="mb-[25px]">
              <h4 className="mb-[15px] text-center text-base font-semibold">
                Марка шасси
              </h4>
              <QueryLayout
                isLoading={isModelsLoading}
                isFetching={isModelsFetching}
                error={modelsError}
              >
                {models ? (
                  <ul className="grid gap-[15px]">
                    {models.map((model) => (
                      <CustomInput
                        type="checkbox"
                        key={model.id}
                        title={model.name}
                        checked={chassisMarkId.includes(model.id)}
                        onChange={() => handleChassisMarkIdChange(model.id)}
                        innerelement={<div>{model.name}</div>}
                      />
                    ))}
                  </ul>
                ) : (
                  <div className="text-center">Выберите тип техники</div>
                )}
              </QueryLayout>
            </div>
          </div>
        </div>
        <div className="grid gap-[15px]">
          <Button
            className="text-base font-medium"
            mode="darkBorder"
            onClick={handleFilterReset}
          >
            Сбросить
          </Button>
          <Button className="text-base font-medium" onClick={handleFilterClose}>
            Продолжить
          </Button>
        </div>
      </div>
    </div>
  );
};
